import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { MContentCardComponent } from './content-card.component';

@NgModule({
  declarations: [MContentCardComponent],
  exports: [MContentCardComponent],
  imports: [CommonModule, NzToolTipModule, NzIconModule]
})
export class MContentCardModule {}
